import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=453bd5c0&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=453bd5c0&prod&lang=css"
import style1 from "./nav.vue?vue&type=style&index=1&id=453bd5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453bd5c0",
  null
  
)

export default component.exports